import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import { DialogForm } from '../../components/DialogForm';
import { requestRelationConfig } from './formDataConfig';
import { ADD_CUSTOMER_PROVIDER_RELATION, DISABLE_CUSTOMER_PROVIDER_RELATIONSHIP } from '../graphQL/queries';
import useStyles from './style';
import { useSnackbar } from 'notistack';
import { Button } from '@material-ui/core';
interface RequestedProps {
  dialogOpen: true | false;
  handleDialogClose: () => void;
  formData?: any;
  workflowCode: any;
  customerProviderRefresh: () => void;
  participantSubscriberRefresh: () => void;
  aggregatorSubscriberRefresh: () => void;
  participantType: any;
  selectedKey: any;
  userRole: any;
}

const Requested = (props: RequestedProps) => {
  const { formData, participantType, selectedKey } = props;
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [dataConfig, setDataConfig] = React.useState<any>([...requestRelationConfig]);
  const [addCustomerProvider] = useMutation(ADD_CUSTOMER_PROVIDER_RELATION);
  const [disableCustomerProvider] = useMutation(DISABLE_CUSTOMER_PROVIDER_RELATIONSHIP);
  const getCustomerCode = (code: any) => {
    if (props.formData.participantType === 'CUSTOMER') return props.formData.participantCode;
    else return code;
  };
  const getProviderCode = (code: any) => {
    if (props.formData.participantType === 'PROVIDER') return props.formData.participantCode;
    else return code;
  };

  const getCustCode = (key: any) => {
    if (participantType === 'CUSTOMER' && key === 'NO_RELATION') {
      return props.formData.customerCode;
    } else if (participantType === 'PROVIDER' && key === 'REQUESTED') {
      return props.formData.customerCode;
    } else if (participantType === 'AGGREGATOR' && key === 'REQUESTED') {
      return props.formData.customerCode;
    }
  };

  const getProvCode = (key: any) => {
    if (participantType === 'CUSTOMER' && key === 'NO_RELATION') {
      return props.formData.participantCode;
    } else if (participantType === 'PROVIDER' && key === 'REQUESTED') {
      return props.formData.providerCode;
    } else if (participantType === 'AGGREGATOR' && key === 'REQUESTED') {
      return 'DEFAULT';
    }
  };

  const handleReject = () => {
    disableCustomerProvider({
      variables: {
        workflowCode: props.workflowCode,
        aggregatorCode: props.formData.providerCode === 'DEFAULT' ? props.formData.aggregatorCode : 'DEFAULT',
        customerCode: formData?.customerCode,
        providerCode: formData?.providerCode
      }
    })
      .then(() => {
        enqueueSnackbar('Relationship disabled successfully !!', { variant: 'success', preventDuplicate: true });
        props.customerProviderRefresh();
        props.participantSubscriberRefresh();
        if (props.workflowCode === 'freightTracking') {
          props.aggregatorSubscriberRefresh();
        }
        props.handleDialogClose();
      })
      .catch(() => {
        enqueueSnackbar('Unable to disable relationship !!', { variant: 'error', preventDuplicate: true });
      });
  };
  const handleSubmit = (values: any) => {
    const connectionConfig = JSON.stringify({
      connectionNotes: values?.connectionNotes
    });

    addCustomerProvider({
      variables: {
        workflowCode: props.workflowCode,
        providerCode: getProvCode(selectedKey),
        // customerCode: participantType==='PROVIDER'?props.formData.customerCode:getCustomerCode(formData?.customerCode),
        customerCode: getCustCode(selectedKey),
        aggregatorCode: props.formData.participantType === 'AGGREGATOR' ? props.formData.partnerCode : 'DEFAULT',
        providerCustomerCode: formData.customerCode,
        additionalCreds: formData?.additionalCreds,
        status: selectedKey === 'NO_RELATION' ? 'REQUESTED' : 'ENABLED',
        operationUrls: formData?.operationUrls || {},
        connectionConfig,
        connectionNote: '',
        method: selectedKey === 'REQUESTED' ? 'PUT' : 'POST'
      }
    })
      .then((res: any) => {
        enqueueSnackbar('Relationship Requested successfully !!', { variant: 'success', preventDuplicate: true });
        props.handleDialogClose();
        props.customerProviderRefresh();
        props.participantSubscriberRefresh();
        if (props.workflowCode === 'freightTracking' && participantType !== 'PROVIDER') {
          props.aggregatorSubscriberRefresh();
        }
      })
      .catch(() => {
        enqueueSnackbar('Unable to add relationship !!', { variant: 'error', preventDuplicate: true });
        props.handleDialogClose();
      });
  };

  const handleConnect = (values: any) => {
    const connectionConfig = JSON.stringify({
      connectionNotes: values?.connectionNotes
    });

    addCustomerProvider({
      variables: {
        workflowCode: props.workflowCode,
        providerCode: getProvCode(selectedKey),
        customerCode: getCustCode(selectedKey),
        aggregatorCode: props.formData.participantType === 'AGGREGATOR' ? props.formData.partnerCode : 'DEFAULT',
        providerCustomerCode: formData.customerCode,
        additionalCreds: formData?.additionalCreds,
        status: 'ENABLED',
        operationUrls: formData?.operationUrls || {},
        connectionConfig,
        connectionNote: '',
        method: 'POST'
      }
    })
      .then((res: any) => {
        enqueueSnackbar('Relationship Connected successfully !!', { variant: 'success', preventDuplicate: true });
        props.handleDialogClose();
        props.customerProviderRefresh();
        props.participantSubscriberRefresh();
        props.aggregatorSubscriberRefresh();
        if (props.workflowCode === 'freightTracking') {
          props.aggregatorSubscriberRefresh();
        }
      })
      .catch(() => {
        enqueueSnackbar('Unable to connect relationship !!', { variant: 'error', preventDuplicate: true });
        props.handleDialogClose();
      });
  };

  return (
    <DialogForm
      key={`ManageRelation-requested`}
      openFn={props.dialogOpen}
      closeFn={props.handleDialogClose}
      dataConfig={[...dataConfig]}
      handleDialogClose={props.handleDialogClose}
      handleDialogSubmit={handleConnect}
      submitlabel={participantType === 'PROVIDER' ? 'Accept' : 'Connect'}
      dialogId="new-participant-dialog"
      title={`${participantType === 'PROVIDER' ? 'Accept' : 'Connect'} Participant`}
      data={selectedKey === 'REQUESTED' ? formData : props.formData}
    >
      <>
        {participantType === 'PROVIDER' && (
          <Button
            data-id="Cancel-Button"
            className={classes.buttonMargin}
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleReject}
            style={{ position: 'absolute', right: '20%', bottom: '2%' }}
          >
            Reject
          </Button>
        )}
        {/* {participantType === 'CUSTOMER' && props.userRole === 'APP_ADMIN' && (
          <Button
            data-id="Connect-Button"
            className={classes.buttonMargin}
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleConnect}
            style={{ position: 'absolute', right: '20%', bottom: '2%' }}
          >
            Connect
          </Button>
        )} */}
      </>
    </DialogForm>
  );
};

export default Requested;
